module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pointManage"
  }, [_c('div', {
    staticClass: "breadcrumb",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("点位管理\n\t\t"), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isselectcampus),
      expression: "isselectcampus"
    }],
    staticClass: "uploadBtn_pM right_f",
    attrs: {
      "with-credentials": true,
      "action": _vm.importurl1,
      "on-success": _vm.chenggong,
      "on-error": _vm.shibai,
      "auto-upload": true,
      "name": "uploadFile"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("导入点位")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pointData.length > 0),
      expression: "pointData.length > 0"
    }],
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportpoints
    }
  }, [_vm._v("导出点位\n\t\t")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pointData.length > 0),
      expression: "pointData.length > 0"
    }],
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setNecessaryPoint
    }
  }, [_vm._v("设置必经点\n\t\t")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.region > 0),
      expression: "region > 0"
    }],
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setRunningFence
    }
  }, [_vm._v("设置围栏")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pointData.length > 0),
      expression: "pointData.length > 0"
    }],
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpRunareaPage
    }
  }, [_vm._v("跑区管理\n\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "selectSchool"
  }, [_c('el-select', {
    staticClass: "selectInput",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "selectInput",
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入高校名称"
    },
    on: {
      "visible-change": _vm.handleChange,
      "change": _vm.getPoints
    },
    model: {
      value: (_vm.region),
      callback: function($$v) {
        _vm.region = $$v
      },
      expression: "region"
    }
  }, _vm._l((_vm.option), function(item) {
    return _c('el-option', {
      key: item.unid,
      attrs: {
        "label": item.name,
        "value": item.unid
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pointData.length > 0),
      expression: "pointData.length > 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pointData
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "prop": "index",
      "label": "序号",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pointsNumber",
      "label": "点位编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pointsDesc",
      "label": "点位名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lon",
      "label": "经度"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lat",
      "label": "纬度"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "relatedPoints",
      "label": "关联点位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mustThoughPoint",
      "label": "必经点位"
    }
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warning",
    staticStyle: {
      "font-size": "14px",
      "margin-left": "20px"
    }
  }, [_c('p', [_vm._v("请先选择一个校区，再进行点位导入和导出操作")]), _vm._v(" "), _c('p', [_vm._v("提示：请导入完整的点位列表！设置点位信息后，之前的点位信息不会被保留！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67a5c657!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiaoyuan/GX/pointManage.vue
// module id = 1057
// module chunks = 0